var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-notification mr-25 notificationDisabled",attrs:{"role":"button","tabindex":"-1","aria-disabled":"true"}},[_c('feather-icon',{staticClass:"text-body iconLogo",attrs:{"icon":"BellIcon","size":"44"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }